import { supabase } from '../lib/supabaseClient';

export async function logActivity(action, description) {
  try {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) return;

    const { data: officer } = await supabase
      .from('officers')
      .select('firstname, lastname')
      .eq('auth_id', user.id)
      .maybeSingle();

    await supabase.from('activity_logs').insert({
      actor_id: user.id,
      actor_name: officer ? `${officer.firstname} ${officer.lastname}`.trim() : null,
      actor_email: user.email,
      action,
      description,
    });
  } catch {
    // Logging must never block the primary action.
  }
}

export async function backfillActorName(actorId, actorName) {
  if (!actorName) return;
  await supabase
    .from('activity_logs')
    .update({ actor_name: actorName })
    .eq('actor_id', actorId)
    .is('actor_name', null);
}

export async function getActivityLogs({ action, limit = 50, before } = {}) {
  let query = supabase
    .from('activity_logs')
    .select('id, actor_name, actor_email, action, description, created_at')
    .order('created_at', { ascending: false })
    .limit(limit);

  if (action) query = query.eq('action', action);
  if (before) query = query.lt('created_at', before);

  const { data, error } = await query;
  if (error) throw error;
  return data;
}
